import Error from './../view/Error';
const system = [
  {
    path: '/error',
    element: Error,
    meta: {
      title: '页面没找到',
      isHeader: true, //是否展示顶部header
    },
  },
]
export default system;
